import { Select } from 'antd';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getGroups } from '../../../api/groups.api';
import useAxios from '../../../hooks/useAxios';
import { IGetGroups, IGroup } from '../../../models/groups.model';
import Button from '../../Button';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import SelectCampus from '../../SelectCampus';
import {
  IEmployeeStatus,
  IGetEmployeeStatus,
} from '../../../models/employees.model';
import { findEmployeeStatus } from '../../../api/employees.api';

interface IProps {
  groupNo: string;
  setGroupNo: (groupNo: string) => void;
  keyword: string;
  setKeyword: (keyword: string) => void;
  onSearch: (memberCode?: string) => void;
  employeeStatus: string;
  setEmployeeStatus: (employeeStatus: string) => void;
}

const StaffSearch: FC<IProps> = ({
  groupNo,
  setGroupNo,
  keyword,
  setKeyword,
  onSearch,
  employeeStatus,
  setEmployeeStatus,
}) => {
  const { t, i18n } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetGroups>();
  //20240716 직원 재직상태 여부 가져오기
  const { data: res2, execute: execute2 } = useAxios<IGetEmployeeStatus>();

  useEffect(() => {
    execute(getGroups());
    execute2(findEmployeeStatus());
  }, []);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>{t('common.column.group')}</label>
            <div>
              <Select
                style={{width:'160px'}}
                value={groupNo}
                onChange={(value) => setGroupNo(value)}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                {res?.data?.map((item: IGroup) => (
                  <Select.Option
                    key={item.groupNo}
                    value={String(item.groupNo)}
                  >
                    {i18n.language === 'ko' ? item.korName : item.engName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <label>{t('common.column.status')}</label>
            <div>
              <Select
                value={employeeStatus}
                onChange={(value) => setEmployeeStatus(value)}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                {res2?.data?.map((item: IEmployeeStatus, empIndx: number) => (
                  <Select.Option
                    key={`key-${empIndx}`}
                    value={String(item.employeeStatus)}
                  >
                    {i18n.language === 'ko'
                      ? item.employeeStatusName
                      : item.employeeStatusName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </li>
          <li>
            <input
              type="text"
              className="form-control"
              placeholder={t('campus.staff.placeholder1')}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') onSearch();
              }}
            />
            <div className="comm-btn__area">
              <Button
                className="btn-basic small black"
                onClick={() => onSearch()}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>	
    </>
  );
};

export default StaffSearch;
